import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InputHookForm from '../../ui/InputHookForm';

export const FormGroup = styled.div`
  align-items: center;
  display: grid;
  grid-gap: 16px;
  grid-template-columns: '1fr';
  padding-bottom: 16px;
`;

const CreateAccountForm = ({ client, isLoading }) => (
  <>
    <FormGroup>
      <InputHookForm
        ariaLabel="First Name"
        name="firstName"
        defaultValue={client.firstName}
        isDisabled={isLoading}
        autoComplete="given-name"
        label="First Name"
        rules={{ required: { value: true, message: 'First name is required' } }}
      />
    </FormGroup>
    <FormGroup>
      <InputHookForm
        ariaLabel="Last Name"
        name="lastName"
        defaultValue={client.lastName}
        isDisabled={isLoading}
        autoComplete="family-name"
        label="Last Name"
        rules={{ required: { value: true, message: 'Last name is required' } }}
      />
    </FormGroup>
    <FormGroup>
      <InputHookForm
        ariaLabel="Email"
        name="email"
        defaultValue={client.email}
        isDisabled={isLoading}
        autoComplete="email"
        label="Email"
        type="email"
        rules={{ required: { value: true, message: 'Email is required' } }}
      />
    </FormGroup>
    <FormGroup>
      <InputHookForm
        ariaLabel="Password"
        name="password"
        defaultValue={client.password}
        isDisabled={isLoading}
        autoComplete="password"
        label="Password"
        type="password"
        rules={{
          required: { value: true, message: 'Password is required' },
          minLength: { value: 10, message: 'Password must be at least 10 characters' },
        }}
      />
    </FormGroup>
  </>
);

CreateAccountForm.propTypes = {
  isLoading: PropTypes.bool,
  client: PropTypes.object.isRequired,
};

CreateAccountForm.defaultProps = {
  isLoading: false,
};

export default CreateAccountForm;
